module.exports = __webpack_public_path__ + "static/img/celoscope-detail-23.8a3cb9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-23.jpg
// module id = WhWK
// module chunks = 52